module.exports = __webpack_public_path__ + "static/media/s_v8_t10.8de27b74.mp3";